<div class="payment-box" [class.box-change-padding]="sendPaymentModel.step === sendPaymentModel.sendPaymentStep.paymentInfo">
  <ng-container *ngIf="sendPaymentModel.step === sendPaymentModel.sendPaymentStep.paymentMandate">
    <np-payment-mandate></np-payment-mandate>
  </ng-container>
  <ng-container *ngIf="sendPaymentModel.step === sendPaymentModel.sendPaymentStep.paymentInfo">
    <np-payment-infomation [sendPaymentType]="sendPaymentType"></np-payment-infomation>
  </ng-container>
  <ng-container *ngIf="sendPaymentModel.step === sendPaymentModel.sendPaymentStep.balanceTradeAvailable">
    <np-balance-trade-available [sendPaymentType]="sendPaymentType"></np-balance-trade-available>
  </ng-container>
  <ng-container *ngIf="sendPaymentModel.step === sendPaymentModel.sendPaymentStep.drawdownSummary">
    <np-drawdown-summary></np-drawdown-summary>
  </ng-container>
  <ng-container *ngIf="sendPaymentModel.step === sendPaymentModel.sendPaymentStep.paymentConfirmation">
    <np-payment-confirmation [sendPaymentType]="sendPaymentType"></np-payment-confirmation>
  </ng-container>
  <ng-container *ngIf="sendPaymentModel.step === sendPaymentModel.sendPaymentStep.validatePayment">
    <np-validate-payment></np-validate-payment>
  </ng-container>
  <ng-container *ngIf="sendPaymentModel.step === sendPaymentModel.sendPaymentStep.paymentComplete">
    <np-payment-complete></np-payment-complete>
  </ng-container>
</div>